import { guest, userInjectionKey } from '#shared'
import { useQuery } from '@tanstack/vue-query'
import { computed, inject, onBeforeUnmount, onMounted, ref, unref, watch, type MaybeRef } from 'vue'
import { getChatQueryOptions, useChatId } from '#entities/chat'
import { useSetUnreadCountMutation } from '../state/use-set-unread-count-mutation'

export function useMessageReading(listEl: MaybeRef<HTMLElement | null>) {
  const chatId = useChatId()
  const currentUser = inject(userInjectionKey)

  const chatQuery = useQuery(getChatQueryOptions(chatId))
  const chat = chatQuery.data

  const currentUnreadCount = computed(() => chat.value?.unreadCount ?? 0)
  const setUnreadCountMutation = useSetUnreadCountMutation(chatId)

  const scrollBottom = ref(0)

  const onScroll = () => {
    const listElVal = unref(listEl)
    if (!listElVal) return

    scrollBottom.value = listElVal.scrollHeight - listElVal.clientHeight - listElVal.scrollTop
  }

  onMounted(() => {
    onScroll()
    unref(listEl)?.addEventListener('scroll', onScroll)
  })

  onBeforeUnmount(() => {
    unref(listEl)?.removeEventListener('scroll', onScroll)
  })

  watch([currentUnreadCount, scrollBottom, setUnreadCountMutation.isPending], ([currentUnreadCount, scrollBottom]) => {
    if (currentUnreadCount === 0) return
    if (scrollBottom > 50) return
    if (setUnreadCountMutation.isPending.value) return
    if (currentUser === guest) return

    setUnreadCountMutation.mutate(0)
  })
}
